import React from "react"
import SiteProvider from "./src/context/SiteProvider"
import "./src/assets/global-styles/index.scss"
import "./src/assets/global-styles/global.scss"

export const wrapRootElement = ({ element }) => (
  <SiteProvider>{element}</SiteProvider>
)
